










































































































































































































































import '@/extensions';
import {SelectBox, TaskInfoCalc} from '@/interfaces/global-data';
import {
    GetTaskInfo,
    IErrors,
    OmnichannelFixedGapType,
    OmnichannelIntersectionType,
    OmnichannelStrategy,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData, {ErrorsMap} from '@/mixins/local-data';
import {
    IOmnichannelStrategyFilters,
    IOmnichannelStrategyIntersections,
    IOmnichannelStrategySaveDto,
    IOmnichannelStrategyStoreParams,
    OmnichannelFixedDiffTypeSelectBox,
    OmnichannelStrategiesOptionsType,
} from '@/pages/omnichannel-strategy/types/data';
import {FixedDiffParams} from '@/pages/omnichannel-strategy/types/FixedDiffParams';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import {OptimalDiffParams} from '@/pages/omnichannel-strategy/types/OptimalDiffParams';
import {BModal, BvModalEvent} from 'bootstrap-vue';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import { EqualityParams } from '@/pages/omnichannel-strategy/types/EqualityParams';

@Component({
    components: {
        vSelect,
        Card,
        SwitchWithLabel
    },
})
export default class OmnichannelStrategyModal extends Mixins(LocalData, Http) {
    @Prop({required: true}) readonly filters!: IOmnichannelStrategyFilters;
    @Prop({required: true}) readonly isFiltersSelected!: boolean;
    @Prop({required: true}) readonly api!: OmnichannelStrategyApi

    private allOption = {value: -1, label: this.$t('shared.selectBox.all') as string};
    private confirmMessage = '';

    private omnichannelStrategiesSet: OmnichannelStrategiesOptionsType = {
        PRICE_EQUALITY: {
            value: OmnichannelStrategy.PRICE_EQUALITY,
            label: this.$t('omnichannelStrategy.strategies.PRICE_EQUALITY') as string,
        },
        FIXED_DIFFERENCE: {
            value: OmnichannelStrategy.FIXED_DIFFERENCE,
            label: this.$t('omnichannelStrategy.strategies.FIXED_DIFFERENCE') as string,
        },
        OPTIMAL_DIFFERENCE_ML: {
            value: OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML,
            label: this.$t('omnichannelStrategy.strategies.OPTIMAL_DIFFERENCE_ML') as string,
        },
    };

    private omnichannelFixedDiffTypeSelectBox: OmnichannelFixedDiffTypeSelectBox = {
        GREATER_THAN: {
            value: OmnichannelFixedGapType.GREATER_THAN,
            label: this.$t('omnichannelStrategy.fixedGapTypes.GREATER_THAN') as string,
        },
        LESS_THAN: {
            value: OmnichannelFixedGapType.LESS_THAN,
            label: this.$t('omnichannelStrategy.fixedGapTypes.LESS_THAN') as string,
        },
        NOT_GREATER_THAN: {
            value: OmnichannelFixedGapType.NOT_GREATER_THAN,
            label: this.$t('omnichannelStrategy.fixedGapTypes.NOT_GREATER_THAN') as string,
        },
        NOT_LESS_THAN: {
            value: OmnichannelFixedGapType.NOT_LESS_THAN,
            label: this.$t('omnichannelStrategy.fixedGapTypes.NOT_LESS_THAN') as string,
        },
        FIX_GAP: {
              value: OmnichannelFixedGapType.FIX_GAP,
              label: this.$tc('omnichannelStrategy.fixedGapTypes.FIX_GAP'),
        },
    }

    private omnichannelStrategiesOptions: Array<SelectBox<OmnichannelStrategy>> = [
        this.omnichannelStrategiesSet.PRICE_EQUALITY,
        this.omnichannelStrategiesSet.FIXED_DIFFERENCE,
        this.omnichannelStrategiesSet.OPTIMAL_DIFFERENCE_ML,
    ];

    private omnichannelFixedDiffTypeOptions: Array<SelectBox<OmnichannelFixedGapType>> = [
        this.omnichannelFixedDiffTypeSelectBox.FIX_GAP,
        this.omnichannelFixedDiffTypeSelectBox.GREATER_THAN,
        this.omnichannelFixedDiffTypeSelectBox.LESS_THAN,
        this.omnichannelFixedDiffTypeSelectBox.NOT_GREATER_THAN,
        this.omnichannelFixedDiffTypeSelectBox.NOT_LESS_THAN,
    ];

    private baseStoreFormatInfo: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [this.allOption],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [this.allOption],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };

    private dependStoreFormatInfo: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [this.allOption],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [this.allOption],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };

    private formErrors: ErrorsMap = {};
    private showFormError: boolean = false;
    private ok_only = false;

    private omnichannelStrategyParams: IOmnichannelStrategySaveDto | null = null;

    private get saveModal(): BModal {
        return this.$refs.saveStrategyModal as BModal
    }

    private get isParamsEditable(): boolean {
        if (this.omnichannelStrategyParams == null) {
            return false
        }
        return this.omnichannelStrategyParams.strategy !== OmnichannelStrategy.PRICE_EQUALITY
    }

    private get isPriceEqualitySelected(): boolean {
      if (this.omnichannelStrategyParams == null) {
        return false
      }
      return this.omnichannelStrategyParams.strategy === OmnichannelStrategy.PRICE_EQUALITY
    }

    private get isFixedDiffSelected(): boolean {
        if (this.omnichannelStrategyParams == null) {
            return false
        }
        return this.omnichannelStrategyParams.strategy === OmnichannelStrategy.FIXED_DIFFERENCE
    }

    private get isOptimalDiffSelected(): boolean {
        if (this.omnichannelStrategyParams == null) {
            return false
        }
        return this.omnichannelStrategyParams.strategy === OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML
    }

    updateStrategy(params: IOmnichannelStrategySaveDto) {
        this.omnichannelStrategyParams = params;
        this.loadInfo();
        this.saveModal.show();
    }

    private confirmAction = () => {
    };

    private cancelAction = () => {
    };

    private createStrategy() {
        const filters = this.filters;
        if (filters.market == null) {
            return
        }
        this.omnichannelStrategyParams = {
            id: null,

            tradingNetId: filters.market.id,
            groupId: filters.groupOfProduct.negativeToNull(),
            categoryId: filters.categoryOfProduct.negativeToNull(),
            subcategoryId: filters.subcategory.negativeToNull(),
            baseStoreParams: {
                formatId: filters.formatSelected.negativeToNull(),
                regionId: filters.regionSelected.negativeToNull(),
                clusterId: filters.clusterSelected.negativeToNull(),
            },
            dependStoreParams: {
                formatId: null,
                regionId: null,
                clusterId: null,
            },
            strategy: OmnichannelStrategy.FIXED_DIFFERENCE,
            strategyParams: new FixedDiffParams(
                    OmnichannelFixedGapType.NOT_GREATER_THAN,
                    0.0,
                    false, true, true),
        };
        this.saveModal.show();
    }

    private loadInfo() {
        if (this.omnichannelStrategyParams == null) {
            return;
        }
        this.getFormatInfo(this.omnichannelStrategyParams.baseStoreParams, this.baseStoreFormatInfo)
        this.getFormatInfo(this.omnichannelStrategyParams.dependStoreParams, this.dependStoreFormatInfo)
        this.getRegionInfo(this.omnichannelStrategyParams.baseStoreParams, this.baseStoreFormatInfo)
        this.getRegionInfo(this.omnichannelStrategyParams.dependStoreParams, this.dependStoreFormatInfo)
        this.getClusterInfo(this.omnichannelStrategyParams.baseStoreParams, this.baseStoreFormatInfo)
        this.getClusterInfo(this.omnichannelStrategyParams.dependStoreParams, this.dependStoreFormatInfo)
    }

    private onSaveButtonClicked(event: BvModalEvent) {
        event.preventDefault();
        this.hideFormErrors('saveStrategy');

        if (this.omnichannelStrategyParams != null) {
            const omnichannelStrategyParams = Object.assign({}, this.omnichannelStrategyParams);
            omnichannelStrategyParams.baseStoreParams = this.normalizeStoreParams(omnichannelStrategyParams.baseStoreParams)
            omnichannelStrategyParams.dependStoreParams = this.normalizeStoreParams(omnichannelStrategyParams.dependStoreParams)
            this.requestIntersections(omnichannelStrategyParams)
                    .then((intersections: IOmnichannelStrategyIntersections) => this.handleIntersections(intersections, omnichannelStrategyParams))
                    .then((params) => this.saveStrategy(params))
                    .then(() => {
                        if (omnichannelStrategyParams != null) {
                            this.$emit('strategySaved', omnichannelStrategyParams.id == null);
                        }
                        this.omnichannelStrategyParams = null;
                        (event.vueTarget as any).hide();
                    })
                    .catch((err) => {
                        this.handleHttpError(err);
                        if (typeof err !== 'undefined' && err != null) {
                            this.showError(this.$t('omnichannelStrategy.messages.saveError') as string);
                        }
                    });
        }
    }

    private normalizeStoreParams(params: IOmnichannelStrategyStoreParams): IOmnichannelStrategyStoreParams {
        const newObject = Object.assign({}, params);
        if (newObject.clusterId === -1) {
            newObject.clusterId = null
        }

        if (newObject.regionId === -1) {
            newObject.regionId = null
        }
        return newObject;
    }

    private requestIntersections(params: IOmnichannelStrategySaveDto): Promise<IOmnichannelStrategyIntersections> {
        return new Promise<IOmnichannelStrategyIntersections>((resolve, reject) => {
            this.api.validateIntersections(params)
                    .then((resp) => {
                        resolve(resp.data)
                    })
                    .catch((err) => {
                        reject(err);
                    });
        });
    }

    private handleIntersections(intersections: IOmnichannelStrategyIntersections, params: IOmnichannelStrategySaveDto): Promise<IOmnichannelStrategySaveDto> {
        if (intersections.id != null) {
            switch (intersections.type) {
                case OmnichannelIntersectionType.CONTRADICT: {
                    return this.showContradictionDialog();
                }

                case OmnichannelIntersectionType.DUPLICATE: {
                    return this.showDuplicateToast(intersections.id)
                }
            }
        } else {
            return Promise.resolve(params);
        }
        return Promise.reject();
    }

    private saveStrategy(params: IOmnichannelStrategySaveDto): Promise<any> {
        return new Promise<IOmnichannelStrategySaveDto>((resolve, reject) => {
            this.api.saveStrategy(params)
                    .then(() => {
                        resolve()
                        this.showInfo(this.$t('omnichannelStrategy.messages.saveSuccess') as string);
                    })
                    .catch((err) => {
                        reject(err)
                    })
        })
    }

    private handleHttpError(err: any) {
        if (err && err.hasOwnProperty('response') && err.response != null && err.response.status === 400) {
            switch (err.response.status) {
                case 400:
                    const errors = err.response.data as IErrors;
                    this.renderErrors('saveStrategy', errors);
                    break;
                case 406:
                    this.showError(this.$t('omnichannelStrategy.messages.intersections') as string);
                    break;
                default:
                    this.showError(this.$t('omnichannelStrategy.messages.saveError') as string);
                    this.$log.error('Error occurred while save strategy', err)
                    break
            }
        }
    }

    private clearParams() {
        this.omnichannelStrategyParams = null;
    }

    private updateFormat(format: number | null, storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        if (format !== storeParams.formatId) {
            storeParams.formatId = format;
            this.resetData(TaskInfoFilterType.format, storeParams, filtersInfo);
        }
    }

    private getFormatInfo(storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format, storeParams))
                .then((data) => {
                    const filterData = data.data;
                    // setTimeout(() => {
                    //     // (this.$refs.formatSelectedRef as any).toggleLoadingtoggleLoading(false);
                    // }, 500);

                    filtersInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });

    }

    private updateRegions(region: number | null, storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        if (storeParams.regionId !== region) {
            storeParams.regionId = region;
            this.resetData(TaskInfoFilterType.region, storeParams, filtersInfo);
        }
    }

    private getRegionInfo(storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region, storeParams))
                .then((data) => {
                    const filterData = data.data;
                    // setTimeout(() => {
                    //     // (this.$refs.updateRegionsRef as any).toggleLoading(false);
                    // }, 500);

                    filtersInfo.storeRegionOptions = [this.allOption, ...(filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    }))];
                })
                .catch((e) => {
                });
    }

    private updateCluster(cluster: number | null, storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        if (cluster !== storeParams.clusterId) {
            storeParams.clusterId = cluster;
            this.resetData(TaskInfoFilterType.cluster, storeParams, filtersInfo);
        }
    }

    private getClusterInfo(storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster, storeParams))
                .then((data) => {
                    const filterData = data.data;
                    filtersInfo.clusterOptions = [this.allOption, ...(filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    }))];
                    // setTimeout(() => {
                    //     // (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                    // }, 500);
                })
                .catch((e) => {
                });
    }

    private resetData(type: TaskInfoFilterType, storeParams: IOmnichannelStrategyStoreParams, filtersInfo: TaskInfoCalc) {
        switch (type) {
            case TaskInfoFilterType.format:
                storeParams.regionId = null;
                storeParams.clusterId = null;
                filtersInfo.storeRegionOptions = [];
                filtersInfo.clusterOptions = [];
                this.getRegionInfo(storeParams, filtersInfo);
                this.getClusterInfo(storeParams, filtersInfo);
                break;
            case TaskInfoFilterType.region:
                storeParams.clusterId = null;
                filtersInfo.clusterOptions = [];
                this.getClusterInfo(storeParams, filtersInfo);
                break;
        }
    }

    private getTaskInfo(taskType: TaskInfoFilterType, storeParams: IOmnichannelStrategyStoreParams): GetTaskInfo {
        const market = this.filters.market;
        if (market == null) {
            return {
                type: taskType,
                tradingId: -1,
                categories: [],
                groups: [],
                subcategory: null,
                segments: null,
                storeFormat: null,
                storeCluster: null,
                storeRegion: null,
                byReports: false,
            }

        }
        let selectedFormat = storeParams.formatId == null || storeParams.formatId <= 0 ? [] : [storeParams.formatId];
        let selectedRegion = storeParams.regionId == null || storeParams.regionId <= 0 ? [] : [storeParams.regionId];
        let selectedCluster = storeParams.clusterId == null || storeParams.clusterId <= 0 ? [] : [storeParams.clusterId];
        switch (taskType) {
            case TaskInfoFilterType.format:
                selectedFormat = [];
                selectedRegion = [];
                selectedCluster = [];
                break;
            case TaskInfoFilterType.region:
                selectedRegion = [];
                selectedCluster = [];
                break;
            case TaskInfoFilterType.cluster:
                selectedCluster = [];
                break;
        }
        return {
            type: taskType,
            tradingId: market.id,
            categories: this.filters.categoryOfProduct == null || this.filters.categoryOfProduct <= 0
                    ? null
                    : [this.filters.categoryOfProduct],
            groups: this.filters.groupOfProduct == null || this.filters.groupOfProduct <= 0
                    ? null
                    : [this.filters.groupOfProduct],
            subcategory: this.filters.subcategory == null || this.filters.subcategory <= 0
                    ? null
                    : [this.filters.subcategory],
            segments: null,
            storeFormat: selectedFormat,
            storeCluster: selectedCluster,
            storeRegion: selectedRegion,
            byReports: false,
        }
    }

    private onStrategyChanged(strategy: OmnichannelStrategy) {
        if (this.omnichannelStrategyParams == null) {
            return
        }
        switch (strategy) {
            case OmnichannelStrategy.FIXED_DIFFERENCE:
                this.omnichannelStrategyParams.strategyParams = new FixedDiffParams(
                        OmnichannelFixedGapType.NOT_GREATER_THAN,
                        0.0,
                        false, true, true);
                break;
            case OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML:
                this.omnichannelStrategyParams.strategyParams = new OptimalDiffParams(
                        0.0, 5.0, 4, true, true,
                );
                break;
          case OmnichannelStrategy.PRICE_EQUALITY:
            this.omnichannelStrategyParams.strategyParams = new EqualityParams(true, true);
            break;
        }
    }

    private setNonNegative(input: string): string {
        const parsed = parseFloat(input);
        if (isNaN(parsed)) {
            return input;
        } else {
            return input;
        }
    }


    private hideFormErrors(form: string) {
        this.formErrors[form] = {};
        this.showFormError = false;
    }

    private renderErrors(form: string, errors: IErrors) {
        this.hideFormErrors(form)
        this.showFormError = true;
        errors.errors.forEach((e) => {
            this.formErrors[form][e.property] = e
        });
    }

    private getMessage(form: string, field: string): string | null {
        if (!this.formErrors.hasOwnProperty(form)) {
            return null;
        }

        if (!this.formErrors[form].hasOwnProperty(field)) {
            return null;
        }
        return this.formErrors[form][field].message;
    }

    private showDuplicateToast(id: number): Promise<IOmnichannelStrategySaveDto> {
        this.ok_only = false;
        return new Promise<IOmnichannelStrategySaveDto>((resolve, reject) => {
            this.showConfirmModal(this.$t('omnichannelStrategy.messages.duplicate') as string, () => {
                        if (this.omnichannelStrategyParams != null) {
                            const params = Object.assign({}, this.omnichannelStrategyParams)
                            params.id = id;
                            resolve(params);
                        }
                    },
                    () => {
                        reject()
                    },
            )
        });
    }

    private showContradictionDialog(): Promise<IOmnichannelStrategySaveDto> {
        this.ok_only = true;
        return new Promise<IOmnichannelStrategySaveDto>((resolve, reject) => {
            this.showConfirmModal(this.$t('omnichannelStrategy.messages.conflict') as string, () => {
                        reject();
                    },
                    () => {
                        reject()
                    },
            )
        });
    }

    private showConfirmModal(message: string, action: () => void, cancel: () => void) {
        this.confirmMessage = message;
        this.confirmAction = action;
        this.cancelAction = cancel;
        (this.$refs.confirmModal as any).show();
    }

    private confirmHide() {
        this.confirmMessage = '';
        this.confirmAction = () => {
        };
        this.cancelAction = () => {
        };
    }
}
